import { Appliance } from "../types";

export interface RentlowCatalog {
  appliances: Appliance[];
}

export const listRentlowCatalog: RentlowCatalog = {
  appliances: [
    /* =========================================================================
       GROUP 1: [Portrait, Portrait, LANDSCAPE (3rd), Portrait, Portrait]
       ========================================================================= */
    {
      id: "water-purifier-kenstar-ro",
      name: "Kenstar RO + UV Water Purifier",
      description: "Kenstar Pureza RO + UV water purifier with multi-stage mineral fortification, active carbon filters, and a high-flow storage tank. Delivers completely sweet and healthy drinking water.",
      categoryId: "water-purifier",
      rentalPrice: 600,
      securityDeposit: 1500,
      images: [
        "https://firebasestorage.googleapis.com/v0/b/rentlow-3551b.firebasestorage.app/o/Images%2FWater%20Purifire%2Fblack-pureza-kenstar-original-imahjh46dhmmqt5h.webp?alt=media&token=cdb912e0-0c8c-4853-9306-08c4d0af622a"
      ],
      availableCities: ["bhopal", "sehore"],
      isActive: true,
      bookedCount: 29,
      sequence: 0,
      isUpcoming: false,
      imageOrientation: "portrait",
      rentType: "month",
      createdAt: new Date().toISOString()
    },
    {
      id: "fridge-haier-silver",
      name: "Haier Sleek Silver Refrigerator (190L)",
      description: "Premium silver finish single-door refrigerator with fast ice-making tech, durable stabilizer-free operation, and optimized power saving. Brand: Haier.",
      categoryId: "fridge",
      rentalPrice: 700,
      securityDeposit: 2000,
      images: [
        "https://firebasestorage.googleapis.com/v0/b/rentlow-3551b.firebasestorage.app/o/Images%2FFridge%2FFridge_silver_candy-removebg-preview.png?alt=media&token=7ea5de88-3c81-4645-8c3a-8fcb713f73a2"
      ],
      availableCities: ["bhopal", "sehore"],
      isActive: true,
      bookedCount: 42,
      sequence: 1,
      isUpcoming: false,
      imageOrientation: "portrait",
      rentType: "month",
      createdAt: new Date().toISOString()
    },
    {
      // 3RD PRODUCT: LANDSCAPE PRODUCT WITH IMAGE
      id: "smart-led-tv-43",
      name: "Smart Android LED TV 43\"",
      description: "Full HD/4K resolution Smart LED TV with built-in Chromecast, high fidelity speakers, and preloaded streaming apps (Prime, Netflix, YouTube). Perfect for your living room.",
      categoryId: "led-tv",
      rentalPrice: 1400,
      securityDeposit: 3500,
      images: [
        "https://firebasestorage.googleapis.com/v0/b/rentlow-3551b.firebasestorage.app/o/Images%2FLed%20Tv%2FLed%20TV.JPG?alt=media&token=07fc667b-5a47-4746-a89b-b9e19d63b1af"
      ],
      availableCities: ["bhopal", "sehore"],
      isActive: true,
      bookedCount: 38,
      sequence: 2,
      isUpcoming: false,
      imageOrientation: "landscape",
      rentType: "month",
      createdAt: new Date().toISOString()
    },
    {
      // 4TH PRODUCT: PORTRAIT PRODUCT
      id: "cooler-black",
      name: "High-Throw Desert Air Cooler (Black)",
      description: "Powerful black tower air cooler with honeycomb cooling pads, multi-directional wheels, smart ice chamber, and high-capacity water tank. Ideal for large rooms.",
      categoryId: "cooler",
      rentalPrice: 800,
      securityDeposit: 2000,
      images: [
        "https://firebasestorage.googleapis.com/v0/b/rentlow-3551b.firebasestorage.app/o/Images%2Fimages%20(2).jpg?alt=media&token=123ce894-aaa1-4907-ab97-bcd7a366e2a2"
      ],
      availableCities: ["bhopal", "sehore"],
      isActive: true,
      bookedCount: 52,
      sequence: 3,
      isUpcoming: false,
      imageOrientation: "portrait",
      rentType: "month",
      createdAt: new Date().toISOString()
    },
    {
      // 5TH PRODUCT: PORTRAIT PRODUCT
      id: "washing-machine-grey",
      name: "Top Load Fully Automatic Washing Machine (Grey)",
      description: "Samsung/LG top-load fully automatic washing machine in modern grey finish. Durable stainless steel drum with intensive wash cycles and smart lint filters.",
      categoryId: "washing-machine",
      rentalPrice: 800,
      securityDeposit: 2000,
      images: [
        "https://firebasestorage.googleapis.com/v0/b/rentlow-3551b.firebasestorage.app/o/Images%2Fwashing%20machine%2FSamsung%20Washing%20Machine.webp?alt=media&token=41cced71-8be5-421d-85ab-df891c8ccd85"
      ],
      availableCities: ["bhopal", "sehore"],
      isActive: true,
      bookedCount: 41,
      sequence: 4,
      isUpcoming: false,
      imageOrientation: "portrait",
      rentType: "month",
      createdAt: new Date().toISOString()
    },

    /* =========================================================================
       GROUP 2: [Portrait, Portrait, LANDSCAPE (8th), Portrait, Portrait]
       ========================================================================= */
    {
      // 6TH PRODUCT: PORTRAIT PRODUCT
      id: "furniture-wardrobe-2door",
      name: "2-Door Wooden Wardrobe with Lock",
      description: "Spacious two-door wooden wardrobe with built-in hanger rod, multiple storage shelves, lockable security drawer, and mirror. Ideal for students, working professionals, and families.",
      categoryId: "furniture",
      rentalPrice: 500,
      securityDeposit: 1000,
      images: [
        "https://images.unsplash.com/photo-1595428774223-ef52624120d2?auto=format&fit=crop&w=600&q=80"
      ],
      availableCities: ["bhopal", "sehore"],
      isActive: true,
      bookedCount: 18,
      sequence: 5,
      isUpcoming: false,
      imageOrientation: "portrait",
      rentType: "month",
      createdAt: new Date().toISOString()
    },
    {
      // 7TH PRODUCT: PORTRAIT PRODUCT
      id: "room-heater-oil",
      name: "Oil-Filled Room Radiator Heater",
      description: "Premium oil-filled radiator room heater with adjustable thermostat, completely silent heating, and overheat protection for supreme comfort during cold months.",
      categoryId: "room-heater",
      rentalPrice: 800,
      securityDeposit: 2000,
      images: [
        "https://firebasestorage.googleapis.com/v0/b/rentlow-3551b.firebasestorage.app/o/Images%2FRoom%20Heater%20on%20Rent.jpg?alt=media&token=33fa190f-40b8-4d32-97a5-a9f203c034f1"
      ],
      availableCities: ["bhopal", "sehore"],
      isActive: true,
      bookedCount: 12,
      sequence: 6,
      isUpcoming: false,
      imageOrientation: "portrait",
      rentType: "month",
      createdAt: new Date().toISOString()
    },
    {
      // 8TH PRODUCT: LANDSCAPE PRODUCT WITH IMAGE (Among portraits 6, 7, 9, 10)
      id: "microwave-ifb",
      name: "IFB Solo Microwave Oven (20L)",
      description: "IFB solo microwave oven with automated speed defrost, multi-stage cooking power levels, and easy-clean cavity. Perfect for reheating, baking, and quick meal prep.",
      categoryId: "microwave",
      rentalPrice: 700,
      securityDeposit: 2000,
      images: [
        "https://firebasestorage.googleapis.com/v0/b/rentlow-3551b.firebasestorage.app/o/Images%2F61n-dJ0vUAL._SX679_.jpg?alt=media&token=e1f606b2-477f-454c-be56-481589ed3992"
      ],
      availableCities: ["bhopal", "sehore"],
      isActive: true,
      bookedCount: 15,
      sequence: 7,
      isUpcoming: false,
      imageOrientation: "landscape",
      rentType: "month",
      createdAt: new Date().toISOString()
    },
    {
      // 9TH PRODUCT: PORTRAIT PRODUCT
      id: "led-tv-stand-combo",
      name: "Smart LED TV with Mobile Stand Combo",
      description: "Premium 43\"/55\" Smart LED TV mounted on a heavy-duty professional mobile metal floor stand with wheels. Engineered for corporate conferences, trade exhibitions, live stage screenings, and events.",
      categoryId: "led-tv",
      rentalPrice: 3500,
      dailyRentalPrice: 3500,
      securityDeposit: 5000,
      images: [
        "https://firebasestorage.googleapis.com/v0/b/rentlow-3551b.firebasestorage.app/o/Images%2FLed%20Tv%2F71xJU44sLfL._SL1500_-removebg-preview.png?alt=media&token=7dcc6622-ce0c-40b5-b251-e01caaf43a82"
      ],
      availableCities: ["bhopal", "sehore"],
      isActive: true,
      bookedCount: 25,
      sequence: 8,
      isUpcoming: false,
      imageOrientation: "portrait",
      rentType: "day",
      createdAt: new Date().toISOString()
    },
    {
      // 10TH PRODUCT: PORTRAIT PRODUCT
      id: "cooler-tower-slim",
      name: "Symphony Diet 3D Slim Tower Air Cooler",
      description: "Symphony Diet 3D high-efficiency slim tower air cooler with i-Pure multi-stage air purification, pop-up touchscreen controls, and low power consumption.",
      categoryId: "cooler",
      rentalPrice: 750,
      securityDeposit: 2000,
      images: [
        "https://images.unsplash.com/photo-1585338107529-13afc5f02586?auto=format&fit=crop&w=600&q=80"
      ],
      availableCities: ["bhopal", "sehore"],
      isActive: true,
      bookedCount: 31,
      sequence: 9,
      isUpcoming: false,
      imageOrientation: "portrait",
      rentType: "month",
      createdAt: new Date().toISOString()
    },

    /* =========================================================================
       GROUP 3: [Portrait, Portrait, LANDSCAPE (13th), Landscape, Landscape]
       ========================================================================= */
    {
      // 11TH PRODUCT: PORTRAIT PRODUCT
      id: "water-purifier-kent",
      name: "Kent Grand Star Alkaline RO + UV Purifier",
      description: "Kent Grand Star transparent tank water purifier with in-tank UV disinfection, real-time digital purity display, and TDS control minerals.",
      categoryId: "water-purifier",
      rentalPrice: 650,
      securityDeposit: 1500,
      images: [
        "https://images.unsplash.com/photo-1548839140-29a749e1bc4e?auto=format&fit=crop&w=600&q=80"
      ],
      availableCities: ["bhopal", "sehore"],
      isActive: true,
      bookedCount: 20,
      sequence: 10,
      isUpcoming: false,
      imageOrientation: "portrait",
      rentType: "month",
      createdAt: new Date().toISOString()
    },
    {
      // 12TH PRODUCT: PORTRAIT PRODUCT
      id: "fridge-double-door",
      name: "Whirlpool Intellifresh Inverter Double Door (240L)",
      description: "Whirlpool frost-free double door inverter refrigerator with microblock technology, anti-odor active carbon, and 12-hour cooling retention.",
      categoryId: "fridge",
      rentalPrice: 1100,
      securityDeposit: 3000,
      images: [
        "https://images.unsplash.com/photo-1571175432267-efb0258593a6?auto=format&fit=crop&w=600&q=80"
      ],
      availableCities: ["bhopal", "sehore"],
      isActive: true,
      bookedCount: 35,
      sequence: 11,
      isUpcoming: false,
      imageOrientation: "portrait",
      rentType: "month",
      createdAt: new Date().toISOString()
    },
    {
      // 13TH PRODUCT: LANDSCAPE PRODUCT WITH IMAGE
      id: "furniture-bed-folding",
      name: "Comfort Bed with Foam Mattress",
      description: "Sturdy single/double metal frame bed with high-density orthopaedic foam mattress. Designed for superior sleep support, durability, and easy relocation.",
      categoryId: "furniture",
      rentalPrice: 500,
      securityDeposit: 1000,
      images: [
        "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=600&q=80"
      ],
      availableCities: ["bhopal", "sehore"],
      isActive: true,
      bookedCount: 22,
      sequence: 12,
      isUpcoming: false,
      imageOrientation: "landscape",
      rentType: "month",
      createdAt: new Date().toISOString()
    },
    {
      // 14TH PRODUCT: LANDSCAPE PRODUCT
      id: "smart-led-tv-32-model-1",
      name: "Smart Android LED TV 32\"",
      description: "Compact and power-efficient Smart LED TV 32 inch with crystal clear HD display, Dolby Audio, and built-in smart assistant. Ideal for bedrooms or small spaces.",
      categoryId: "led-tv",
      rentalPrice: 700,
      securityDeposit: 2000,
      images: [
        "https://firebasestorage.googleapis.com/v0/b/rentlow-3551b.firebasestorage.app/o/Images%2FLed%20Tv%2FLED%20tv%202.JPG?alt=media&token=28e3995e-22c0-4054-a4fd-6c12d6f5836a"
      ],
      availableCities: ["bhopal", "sehore"],
      isActive: true,
      bookedCount: 24,
      sequence: 13,
      isUpcoming: false,
      imageOrientation: "landscape",
      rentType: "month",
      createdAt: new Date().toISOString()
    },
    {
      // 15TH PRODUCT: LANDSCAPE PRODUCT
      id: "vacuum-cleaner-agaro",
      name: "Agaro High-Suction Dry Vacuum Cleaner",
      description: "Agaro multi-surface dry vacuum cleaner with advanced HEPA filters, adjustable suction control, and multiple nozzle accessories. Excellent for carpets, floors, and upholstery.",
      categoryId: "vacuum-cleaner",
      rentalPrice: 600,
      dailyRentalPrice: 600,
      securityDeposit: 2000,
      images: [
        "https://firebasestorage.googleapis.com/v0/b/rentlow-3551b.firebasestorage.app/o/Images%2FVacuum%20Clener%2F61B8-nfHqlL._AC_CR0%2C0%2C0%2C0_SX615_SY462_.jpg?alt=media&token=0bc46d2d-d07c-43c2-be43-008f4a49d0dc"
      ],
      availableCities: ["bhopal", "sehore"],
      isActive: true,
      bookedCount: 8,
      sequence: 14,
      isUpcoming: false,
      imageOrientation: "landscape",
      rentType: "day",
      createdAt: new Date().toISOString()
    }
  ]
};
